$(function () {
    $("#front-image:file").on("change", function (e) {
        if (this.files[0])
            $('.image-name-1').html(this.files[0].name);
        else
            $('.image-name-1').html('');
        var file_type = this.files[0].type;
        var image = this.files[0];
        if (image.size < 5242879) {
            $('.loader-1').html(`<div class="Loading"></div>`);
            console.log(file_type);
            if (file_type == 'application/pdf') {
                setTimeout(function () {
                    var canvasElement = document.querySelector(".iframe-1")
                    var file = image;
                    if (file.type != "application/pdf") {
                        console.error(file.name, "is not a pdf file.")
                        return
                    }
                    var fileReader = new FileReader();
                    fileReader.onload = function () {
                        var typedarray = new Uint8Array(this.result);
                        PDFJS.getDocument(typedarray).then(function (pdf) {
                            console.log("the pdf has ", pdf.numPages, "page(s).")
                            pdf.getPage(pdf.numPages).then(function (page) {
                                var viewport = page.getViewport(2.0);
                                var canvas = document.querySelector(".iframe-1");
                                canvas.height = viewport.height;
                                canvas.width = viewport.width;
                                page.render({
                                    canvasContext: canvas.getContext('2d'),
                                    viewport: viewport
                                });
                            });
                        });
                    };
                    fileReader.readAsArrayBuffer(file);
                    $('.loader-1').html(``);
                    $('.iframe-1').show();
                    $('.placeholder-1').hide();
                    $('.upload-1').addClass('mrk-image-added')
                }, 3500)
            } else if (file_type == 'application/postscript' || file_type == '' || file_type == 'image/vnd.adobe.photoshop') {
                setTimeout(function () {
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        $('.iframe-1').hide();
                        if (file_type == 'application/postscript')
                            $('.placeholder-1').show().attr('src', "//cdn.shopify.com/s/files/1/0613/5919/4306/files/AI.png?v=6283552184397460155");
                        if (file_type == '' || file_type == 'image/vnd.adobe.photoshop')
                            $('.placeholder-1').show().attr('src', "//cdn.shopify.com/s/files/1/0613/5919/4306/files/PSD.png?v=11552293306837961472");
                        $('.placeholder-1').show();
                    }
                    reader.readAsDataURL(image);
                    $('.loader-1').html(``);
                }, 3500);
            } else {
                setTimeout(function () {
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        $('.iframe-1').hide();
                        $('.placeholder-1').show().attr('src', reader.result);
                    }
                    reader.readAsDataURL(image);
                    $('.loader-1').html(``);
                    $('.upload-1').addClass('mrk-image-added')
                }, 3500);
            }
        } else {
            alert('Excedded File Size');
            $(this).val('');
            $('#front-image').val('').trigger('change');
        }
    });
    $("#back-image:file").on("change", function (e) {

        if (this.files[0])
            $('.image-name-2').html(this.files[0].name);
        else
            $('.image-name-2').html('');
        var file_type = this.files[0].type;
        var image = this.files[0];
        if (image.size < 5242879) {
            $('.loader-2').html(`<div class="Loading"></div>`);
            if (file_type == 'application/pdf') {
                setTimeout(function () {
                    var canvasElement = document.querySelector(".iframe-2")
                    var file = image;
                    if (file.type != "application/pdf") {
                        console.error(file.name, "is not a pdf file.")
                        return
                    }
                    var fileReader = new FileReader();
                    fileReader.onload = function () {
                        var typedarray = new Uint8Array(this.result);
                        PDFJS.getDocument(typedarray).then(function (pdf) {
                            console.log("the pdf has ", pdf.numPages, "page(s).")
                            pdf.getPage(pdf.numPages).then(function (page) {
                                var viewport = page.getViewport(2.0);
                                var canvas = document.querySelector(".iframe-2");
                                canvas.height = viewport.height;
                                canvas.width = viewport.width;
                                page.render({
                                    canvasContext: canvas.getContext('2d'),
                                    viewport: viewport
                                });
                            });
                        });
                    };
                    fileReader.readAsArrayBuffer(file);
                    $('.loader-2').html(``);
                    $('.iframe-2').show();
                    $('.placeholder-2').hide();
                    $('.upload-2').addClass('mrk-image-added')
                }, 3500)
            } else if (file_type == 'application/postscript' || file_type == '' || file_type == 'image/vnd.adobe.photoshop') {
                setTimeout(function () {
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        $('.iframe-2').hide();
                        if (file_type == 'application/postscript')
                            $('.placeholder-2').show().attr('src', "//cdn.shopify.com/s/files/1/0613/5919/4306/files/AI.png?v=6283552184397460155");
                        if (file_type == '' || file_type == 'image/vnd.adobe.photoshop')
                            $('.placeholder-2').show().attr('src', "//cdn.shopify.com/s/files/1/0613/5919/4306/files/PSD.png?v=11552293306837961472");
                        $('.placeholder-2').show();
                    }
                    reader.readAsDataURL(image);
                    $('.loader-2').html(``);
                }, 3500);
            } else {
                setTimeout(function () {
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        $('.iframe-2').hide();
                        $('.placeholder-2').show().attr('src', reader.result);
                    }
                    reader.readAsDataURL(image);
                    $('.loader-2').html(``);
                    $('.upload-2').addClass('mrk-image-added')
                }, 3500);
            }
        } else {
            alert('Excedded File Size');
            $(this).val('');
            $('#back-image').val('').trigger('change');
        }
    });
    $('#ProductPopup-mrk-pop').click(function () {
        $('#PopupModal-mrk-pop').addClass('form-active');
    });
    $('#ModalClose-mrk-pop').click(function () {
        $('#PopupModal-mrk-pop').removeClass('form-active');
    });
    $('.mrk-close-button').click(function () {
        if ($('#front-image').val() != '') {
            $('product-form form .product-form__submit').click();
            $('#ModalClose-mrk-pop').click();
        } else {
            $('.upload-1').addClass('mrk-error');
            document.querySelector('.upload-1').scrollIntoView({
                behavior: "smooth"
            });
            setTimeout(function () {
                $('.upload-1').removeClass('mrk-error');
            }, 5000)
        }
    });
    $('[name="back_type"]').change(function () {
        if ($(this).val() == 'own') {
            $('.mrk-back-side-containder').removeClass('stander-back');
        } else {
            $('.mrk-back-side-containder').addClass('stander-back');
        }
    });
    $('[name="Shape"]').change(function () {
        if ($('[name="Shape"]:checked').val() == 'Round') {
            $('[name="Size"]').each(function () {
                $(this).parents('.mrk-var-inner').show();
                if ($(this).val().includes('x')) {
                    $(this).removeClass('mrk_showing');
                    $(this).parents('.mrk-var-inner').hide();
                } else {
                    $(this).addClass('mrk_showing');
                }
            });
          $('.mrk_showing:eq(0)').prop('checked', true);
        } else {
            $('[name="Size"]').each(function () {
                $(this).parents('.mrk-var-inner').show();
                if (!$(this).val().includes('x')) {
                    $(this).removeClass('mrk_showing');
                    $(this).parents('.mrk-var-inner').hide();
                } else {
                    $(this).addClass('mrk_showing');
                }
            });
          $('.mrk_showing:eq(0)').prop('checked', true);
        }
    });
    $('[name="Shape"]:checked').trigger('change');
});